import { Auth } from 'aws-amplify'

const signOut = async () => {
  try {
    await Auth.signOut({ global: true })
  } catch (error) {
    console.log('error signing out: ', error)
  }
}

export default signOut
